import { serverHttp as Request } from './http'

class PricingService {
  getList() {
    return Request.get('sharkfoto/get_pricing')
  }
  createSubscriptionCheckoutSession(userId, params) {
    return Request.post(`sharkfoto/create_subscription_checkout_session?user_id=${userId}`, params)
  }
  createAddonCheckoutSession(userId, params) {
    return Request.post(`sharkfoto/create_addon_checkout_session?user_id=${userId}`, params)
  }
  createAddonDirectCharge(userId, params) {
    return Request.post(`sharkfoto/create_addon_direct_charge?user_id=${userId}`, params)
  }
  modifySubscribe(userId, params) {
    return Request.post(`sharkfoto/modify_subscription?user_id=${userId}`, params)
  }
  cancelSubscribe(userId, params) {
    return Request.post(`sharkfoto/cancel_subscription?user_id=${userId}`, params)
  }
  updateSubscribe(userId, params) {
    return Request.post(`sharkfoto/update_subscription?user_id=${userId}`, params)
  }
  downgradeSubscribe(userId, params) {
    return Request.post(`sharkfoto/downgrade_subscription?user_id=${userId}`, params)
  }
}

export default new PricingService()
